/**
 * Scroll to top when wizard submit button is clicked
 * This handles third-party app buttons that may focus in the center/footer
 */
(function() {
  'use strict';

  function scrollToTop() {
    // Scroll to the very top of the page
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    
    // Also ensure focus goes to top element if needed
    // This helps with accessibility and ensures we're at the top
    if (document.body) {
      document.body.scrollTop = 0;
    }
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
  }

  function handleWizardSubmitClick(event) {
    // Check if the clicked element or its parent has the wizard__submit class
    const button = event.target.closest('.wizard__submit');
    
    if (button) {
      // Small delay to ensure any third-party app actions complete first
      setTimeout(function() {
        scrollToTop();
      }, 2500);
    }
  }

  function handleDismissButtonClick(event) {
    // Check if the clicked element is the SVG or inside the dismiss button structure
    const clickedElement = event.target;
    
    // Check if clicked element is the SVG itself
    if (clickedElement.matches && clickedElement.matches('.gfb-style-material_outlined .message .dismiss svg')) {
      window.location.reload();
      return;
    }
    
    // Check if clicked element is inside the dismiss button structure
    const dismissContainer = clickedElement.closest('.gfb-style-material_outlined .message .dismiss');
    if (dismissContainer) {
      const svg = dismissContainer.querySelector('svg');
      if (svg && (svg === clickedElement || svg.contains(clickedElement))) {
        // Reload the page when dismiss button is clicked
        window.location.reload();
      }
    }
  }

  // Initialize when DOM is ready
  function init() {
    // Use event delegation to handle dynamically added buttons
    document.addEventListener('click', handleWizardSubmitClick, true);
    
    // Handle dismiss button clicks to reload the page
    document.addEventListener('click', handleDismissButtonClick, true);
    
    // Also listen for form submissions that might trigger the button
    document.addEventListener('submit', function(event) {
      const form = event.target;
      const submitButton = form.querySelector('.wizard__submit');
      
      if (submitButton) {
        setTimeout(function() {
          scrollToTop();
        }, 2500);
      }
    }, true);
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM is already ready
    init();
  }
})();

